"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CircleSocialPinterest.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CircleSocialPinterest = function CircleSocialPinterest(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "circle-icon",
    viewBox: "0 0 516.98 516.99"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Pinterest icon"), _react2.default.createElement("path", {
    className: "pinterest",
    d: "M258.49 0C115.73 0 0 115.73 0 258.49 0 368 68.13 461.62 164.29 499.28c-2.26-20.45-4.3-51.91.9-74.23 4.7-20.17 30.31-128.49 30.31-128.49s-7.73-15.49-7.73-38.38c0-35.94 20.83-62.78 46.77-62.78 22.05 0 32.71 16.56 32.71 36.41 0 22.18-14.12 55.34-21.41 86.06-6.09 25.73 12.9 46.71 38.28 46.71 45.94 0 81.26-48.44 81.26-118.37 0-61.89-44.47-105.16-108-105.16-73.55 0-116.72 55.17-116.72 112.18 0 22.21 8.56 46 19.24 59a7.73 7.73 0 0 1 1.79 7.41c-2 8.17-6.32 25.72-7.18 29.32-1.13 4.73-3.75 5.73-8.65 3.46-32.28-15-52.47-62.23-52.47-100.14 0-81.54 59.25-156.42 170.8-156.42 89.67 0 159.36 63.9 159.36 149.29 0 89.09-56.17 160.78-134.13 160.78-26.19 0-50.82-13.61-59.25-29.68 0 0-13 49.35-16.1 61.45-5.84 22.45-21.59 50.6-32.13 67.77A258.36 258.36 0 0 0 258.49 517C401.25 517 517 401.25 517 258.49S401.25 0 258.49 0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = CircleSocialPinterest;